import { useDispatch } from 'react-redux';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import * as actions from './actionCreators';
import { useJspVariables, useAppContext, useAuth, useDebugRender } from '../hooks';
import { IceIcon, PageContainer } from '../components';
import Button from '@mui/material/Button';

const PageNotAuthorized = () => {
    useDebugRender('PageNotAuthorized');
    const dispatch = useDispatch();
    const { jspVariables, launcher, panelStyle } = useJspVariables();
    const { jspLoggedInAs } = jspVariables;
    const { getLabelFromJspVariables } = useAppContext(jspVariables);
    const { authenticatedUser } = useAuth();

    const logoutUserToken = () => {
        if (authenticatedUser && authenticatedUser.user) {
            dispatch({ type: actions.USER_INPUT_APP_KEY_CHANGE, data: '' });
            dispatch(actions.logoutUserToken(authenticatedUser.user, false, false));
        }
    };

    const onContinueClick = () => {
        if (jspLoggedInAs) {
            const credentials = jspLoggedInAs.split('/');
            if (credentials && credentials.length > 0) {
                dispatch({ type: actions.USER_INPUT_APP_KEY_CHANGE, data: '' });
                dispatch(actions.logoutUserToken(credentials[0], false, false));
            }
        }
    };

    return (
        <PageContainer id="pageNotAuthorized" dataAutomationId="page_not_authorized">
            <Box style={panelStyle}>
                <IceIcon launcher={launcher} />
                <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <Link component="button" variant="body2" onClick={logoutUserToken}
                        data-automation-id="not_authorized_logout_link">
                        {getLabelFromJspVariables('action_logout')}
                    </Link>
                </Box>
                <Typography fontWeight={500}>{getLabelFromJspVariables('logout_and_log_back_in')}</Typography>
                <Box sx={{ mt: 2 }}>
                    <Button variant="contained"
                        onClick={onContinueClick}
                        data-automation-id="not_authorized_continue_btn">
                        {getLabelFromJspVariables('action_continue')}
                    </Button>
                </Box>
            </Box>
        </PageContainer>
    );
};

export default PageNotAuthorized;
